import { render, staticRenderFns } from "./ResultDisplay.vue?vue&type=template&id=b8d55586&scoped=true&"
import script from "./ResultDisplay.vue?vue&type=script&lang=js&"
export * from "./ResultDisplay.vue?vue&type=script&lang=js&"
import style0 from "./ResultDisplay.vue?vue&type=style&index=0&id=b8d55586&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8d55586",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VImg,VRow})
